import { enumFinanceAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideFileText, LucideReceipt } from 'lucide-react';

import {
  $remoteFinanceOutboxEventCounts,
  useFinanceAggregateTypeFilter,
} from '@/audit-log/_state/financeEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumFinanceAggregateType.Bill,
    labelKey: 'bill' as const,
    icon: LucideReceipt,
    countKey: 'bill' as const,
  },
  {
    type: enumFinanceAggregateType.Invoice,
    labelKey: 'invoice' as const,
    icon: LucideFileText,
    countKey: 'invoice' as const,
  },
];

export const FinanceEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useFinanceAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue(
    $remoteFinanceOutboxEventCounts,
  );

  const totalCount = counts ? counts.bill + counts.invoice : 0;

  return (
    <Col className="@FinanceEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.financeEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.financeEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
